import { defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { committedUnitTarget, liveEnemyFieldCard } from './furniture_helpers.js';
export const DropThePianoCard = defineGameCard({
    id: 'drop_the_piano',
    gameplay: {
        type: 'SPELL',
        cost: 4,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'enemy',
                cardTypes: ['UNIT', 'STRUCTURE'],
                cardinality: { min: 1, max: 1 },
                where: ({ unit, context }) => unit.controllerId !== context.viewerId,
            })),
        ]),
    },
    presentation: {
        name: 'Уронить рояль',
        description: 'Нанесите 6 урона выбранной карте соперника на поле.',
        glyph: {
            colors: ['#F3CC37', '#10213A', '#1F293D', '#D5B390', '#000000'],
            rows: [
                '.............1......',
                '...1.........11.....',
                '...1....2222..1.....',
                '..1....233332...1...',
                '1.....23333332..1...',
                '1....223333332..11..',
                '.1..2233333332...1..',
                '...222333333332.....',
                '..22223333333332....',
                '.2222233333333332...',
                '.24222223333333222..',
                '.24542222233333222..',
                '.24445422223222222..',
                '..222445422222222...',
                '....222445422222....',
                '......222445422..1..',
                '..1.....2224442..1..',
                '...1...1..2222..1...',
                '...1....1.....1.....',
                '....1....1...1......',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = committedUnitTarget(ctx);
            const controllerId = ctx.self?.controllerId;
            if (targetId === undefined || controllerId === undefined)
                return;
            const target = liveEnemyFieldCard(ctx, targetId, controllerId);
            if (target !== undefined) {
                ctx.ops.dealDamage({ kind: 'unit', instanceId: target.id }, 6);
            }
        }),
    ],
    ui: {
        planning: {
            steps: { target: { label: 'Выберите карту соперника' } },
        },
    },
});
//# sourceMappingURL=drop_the_piano.js.map